var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1175 14.702L13.9993 15.5C11.2176 14.1038 9.49934 12.5 8.49934 10L9.26929 5.8699L7.81386 2H4.06294C2.93539 2 2.04748 2.93178 2.21588 4.04668C2.63629 6.83 3.87587 11.8765 7.49934 15.5C11.3045 19.3052 16.785 20.9564 19.8013 21.6127C20.9661 21.8662 21.9993 20.9575 21.9993 19.7655V16.1812L18.1175 14.702Z",
    stroke: "#442A0B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/callIcon.26f155486e8aeae6bbd3677f56fb4817.svg";
export { ForwardRef as ReactComponent };